import { render, staticRenderFns } from "./RouterLinkNav.vue?vue&type=template&id=314e04f8"
import script from "./RouterLinkNav.vue?vue&type=script&lang=js"
export * from "./RouterLinkNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports